import times from 'lodash/times';
import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Column } from '../../../../CommonComponents/OPL/Grid/Column';
import { Grid } from '../../../../CommonComponents/OPL/Grid/Grid';
import { Row } from '../../../../CommonComponents/OPL/Grid/Row';
import { Shimmer } from '../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { TextLoading } from '../../../../CommonComponents/OPL/Text/Text.loading';
import { BucketLoading } from './components/Bucket/Bucket.loading';
import { NetWorthLoading } from './components/NetWorth/NetWorth.loading';
import { NetWorthMakeupLoading } from './components/NetWorthMakeup/NetWorthMakeup.loading';

export const AssetBucketingResultsLoading = () => {
  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb="24">
        <Shimmer width={180} height={32} />

        <Shimmer width={120} height={32} />
      </Box>

      <TextLoading height="h3" width={230} mb="8" />
      <TextLoading width={800} mb="8" />
      <TextLoading width={500} />

      <Grid gutter={24} mt="24">
        <Row mb="24">
          <Column width={4}>
            <NetWorthLoading />
          </Column>

          <Column width={8}>
            <NetWorthMakeupLoading />
          </Column>
        </Row>

        <Row>
          {times(3).map(key => (
            <Column key={key} width={4}>
              <BucketLoading />
            </Column>
          ))}
        </Row>
      </Grid>
    </>
  );
};
